const validators = {
  postalCode: (value: string) => /^[0-9]{5}$|^[0-9]{5}-[0-9]{4}$/.test(value),
  name: (value: string) => /^[A-Za-z][A-Za-z'\-\s’]*$/.test(value),
  city: (value: string) => /^[A-Za-z’'-][A-Za-z\s’'-]*$/.test(value),
  company: (value: string) => /^(?![ &])[a-zA-Z0-9\s\-+'&’]+$/.test(value),
  street: (value: string) => /^[a-zA-Z0-9 ,.\-'’]*$/.test(value),
};

export default validators;
